import './wildkitchenandbar/style';
import FormStructure from './wildkitchenandbar/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js